// Currency formatting for the paywall, driven by Stripe's price data. Amounts
// come from Stripe as integer minor units (e.g. cents); the currency comes from
// the Stripe Price object. Formatting follows the resolved paywall locale so the
// number/symbol placement matches the language the user is seeing.

import { paywallLocale, toIntlLocale, type PaywallLocale } from "./locale";

// Currencies with no minor unit (amounts are whole numbers, not cents). Stripe
// treats these as zero-decimal. Vietnamese đồng (VND) is the relevant one here.
const ZERO_DECIMAL_CURRENCIES = new Set(["vnd", "jpy", "krw", "clp"]);

// Formats a Stripe minor-unit amount into a localized currency string.
// e.g. formatCurrency(499, "usd") -> "$4.99"
export function formatCurrency(
  minorUnitAmount: number,
  currency: string,
  locale: PaywallLocale = paywallLocale
): string {
  const isZeroDecimal = ZERO_DECIMAL_CURRENCIES.has(currency.toLowerCase());
  const amount = isZeroDecimal ? minorUnitAmount : minorUnitAmount / 100;

  return new Intl.NumberFormat(toIntlLocale(locale), {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(amount);
}
